import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './par-language-communication.reducer';

export const ParLanguageCommunicationDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [loadModal, setLoadModal] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
    setLoadModal(true);
  }, []);

  const parLanguageCommunicationEntity = useAppSelector(state => state.parLanguageCommunication.entity);
  const updateSuccess = useAppSelector(state => state.parLanguageCommunication.updateSuccess);

  const handleClose = () => {
    props.history.push('/par-language-communication');
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(parLanguageCommunicationEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="parLanguageCommunicationDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="almobadaraMasterDataApp.parLanguageCommunication.delete.question">
        <Translate
          contentKey="almobadaraMasterDataApp.parLanguageCommunication.delete.question"
          interpolate={{ id: parLanguageCommunicationEntity.id }}
        >
          Are you sure you want to delete this ParLanguageCommunication?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-parLanguageCommunication" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Archive</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ParLanguageCommunicationDeleteDialog;
